import styled from 'styled-components';
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div)`
  margin-left: 8.8rem;
  margin-right: 8.8rem;

  ${(props) => props.theme.mediaQueries.mobile} {
    margin: 0 0 0 0;
  }
`;

export const Title = styled.h2`
  ${(props) => props.theme.fonts.interSemibold32};
  color: ${(props) => props.theme.colors.white100};

  ${(props) => props.theme.mediaQueries.mobile} {
    text-align: center;
    ${(props) => props.theme.fonts.interSemibold24_140};
  }
`;

export const List = styled.div`
  margin-bottom: 4.3rem;
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start; */
`;

export const Item = styled.div`
  margin-top: 3.2rem;
  padding-bottom: 2.4rem;
  border-bottom: .2rem solid ${(props) => props.theme.colors.darkBlue};
  max-height: 5rem;
  overflow: hidden;
  /* transition-property: max-height; */
  /* transition: all 1s; */
  cursor: pointer;

  /* transform: scaleY(0.2); */
  /* transition: all 0.3s ease-out;
  height: auto;
  flex: 1; */

  transition: all 0.3s ease-out;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  img {
    transition: .3s all;
  }

  &.active {
    max-height:50rem;
    /* transform: scaleY(1); */
    /* flex: 0; */
    img {
      transform: rotate(180deg);
    }
  }
`;

export const Question = styled.span`

  ${(props) => props.theme.fonts.interSemibold18};
  color: ${(props) => props.theme.colors.white100};
  padding-bottom: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;

`;

export const Answer = styled.p`

  ${(props) => props.theme.fonts.interMedium16_3};
  color: ${(props) => props.theme.colors.secondary};
  white-space: break-spaces;

  transition: all 0.3s ease-out;
  height: auto;
  flex: 0;

  &.active {
    flex: 1;
  }

`;

export const ArrowIcon = styled.img`

  width: 2.4rem;

`;